module.exports = __webpack_public_path__ + "static/media/edit-primary.a5ea782c.svg";